export const privacyPolicyData = [
  {
    "type": "h1",
    "content": "Pexar Privacy Policy"
  },
  {
    "type": "p",
    "content": "Pexar Co., Ltd. (including its subsidiaries and affiliates, hereafter collectively referred to as “pexar,” “Us,” “Our,” or “We”) operates https://pexar.com/ (the “site”) and provides the pexar mobile app for Android and iOS (the “app”) and the pexar frame app (the “frame”)."
  },
  {
    "type": "p",
    "content": "We take your privacy seriously and are committed to protecting the information we collect. We have written our privacy policy to be understandable for humans (not just lawyers). By using our app or frame, future products, services or features we develop and introduce, or our website (together the “Services”), you consent to the collection, processing and disclosure of data concerning you in accordance with this Privacy Policy."
  },
  {
    "type": "h2",
    "content": "Data collection"
  },
  {
    "type": "p",
    "content": "Information we collect when you use our Services:"
  },
  {
    "type": "p",
    "content": "We collect some of the information generated by our services (“Log Data”). This Log Data may include information such as your device’s Internet Protocol (“IP”) address, browser type, browser version, the pages of our site that you visit, the time and date of your visit or use of the app or frame, the time spent on those pages, which IPs communicate together through our servers and other statistics. IP addresses are anonymized wherever possible."
  },
  {
    "type": "p",
    "content": "Photos, videos and reactions shared through the app are never collected by us or third parties. Communication between app and frame is end-to-end encrypted which makes it impossible for us or any third party to see what you send, including your photos or videos."
  },
  {
    "type": "p",
    "content": "This ensures your privacy when sending media through our Services."
  },
  {
    "type": "p",
    "content": "Cookies and Similar Technologies:"
  },
  {
    "type": "p",
    "content": "Cookies are small pieces of data that are stored on your mobile phone, computer, or other device. Pixels, often used in connection with cookies, are small instances of code placed in web pages that do things like allow another server to measure how frequently web pages are viewed and used."
  },
  {
    "type": "p",
    "content": "We use different categories of cookies and similar technologies on our Services. These include: (i) strictly necessary cookies required for functionality, (ii) analytics cookies to understand usage and improve the Services, (iii) functional cookies to enhance user experience, and (iv) advertising/targeting cookies. Except for strictly necessary cookies, we only place cookies where you have provided your explicit consent in accordance with the ePrivacy Directive and GDPR. You can withdraw or change your cookie preferences at any time using your browser/device settings."
  },
  {
    "type": "p",
    "content": "Third parties may also use cookies to collect information about your activities on our website. Your browser or device may offer you control over the use of cookies or other technologies when you use the Services. For example, you may be able to set your browser or device to disable, clear, reset or block the use of cookies or similar technologies."
  },
  {
    "type": "p",
    "content": "Information we collect when you create an Account:"
  },
  {
    "type": "p",
    "content": "When you create an Account in your Pexar app you may provide us with the following data: User name, Email address. No other personal information is collected from the creation of the user account."
  },
  {
    "type": "h2",
    "content": "Third Party Data Processing"
  },
  {
    "type": "p",
    "content": "We use automated devices and applications to evaluate usage of our app, frame devices, the Pexar solution infrastructure and our website. We also may use other analytics to evaluate our Services. We use these tools to help us improve our Services, performance and user experience. We do not share your personal information with these providers. Some of our providers of these devices and applications are either located or have parent companies in the US. Where this is the case, our providers are certified under the EU-U.S. Data Protection Framework and all data transfer is protected with the necessary safeguards in accordance with GDPR art. 45."
  },
  {
    "type": "h2",
    "content": "Remote Access for Technical Support and Maintenance"
  },
  {
    "type": "p",
    "content": "To ensure the stability of our Services and provide necessary technical support, members of our operations and engineering teams located in <strong>mainland China</strong> may occasionally require remote access to certain production data (such as system logs and diagnostic information)."
  },
  {
    "type": "p",
    "content": "Please be assured that such access is strictly governed by the <strong>principle of least privilege</strong> and is subject to rigorous <strong>internal approval workflows</strong>. We implement comprehensive technical and organizational measures to ensure that any such remote access is secure, monitored, and limited to what is strictly necessary for maintenance and troubleshooting purposes, in full compliance with applicable data protection laws."
  },
  {
    "type": "h2",
    "content": "Legal basis for processing personal data"
  },
  {
    "type": "p",
    "content": "When we process your personal data, we always ensure that the processing is in accordance with the GDPR, namely that we always have a legal basis for the processing."
  },
  {
    "type": "p",
    "content": "The legal basis for our processing of analytic data from cookies on our website is the GDPR art. 6(1)(a)"
  },
  {
    "type": "p",
    "content": "The legal basis for our processing of analytic data from our website and app, that is not derived from the use of cookies, is the GDPR Art. 6 (1)(f), as it is in our legitimate interest to make our Services available to you, including improving and optimising the user experience."
  },
  {
    "type": "p",
    "content": "Lastly the processing of contact information such as e-mail addresses and names are processed based on the GDPR art 6(1)(f) as it is in our legitimate interest to be able to contact our customers. Where we use your contact information to send newsletters and other marketing material, this is based on GDPR Art. 6(1)(a) (your consent) . You can withdraw your consent at any time by following the unsubscribe link in our emails or through the relevant settings in our app."
  },
  {
    "type": "p",
    "content": "Our Services are not directed to children under the age of 16 (or the minimum age of consent for data processing in your jurisdiction). We do not knowingly collect personal data from children. If we learn that we have collected personal data from a child without appropriate consent, we will delete such information promptly."
  },
  {
    "type": "h2",
    "content": "Your rights as data subject"
  },
  {
    "type": "p",
    "content": "You have the rights as described below which you can exercise by contacting us at the below mentioned contact information. Your request will be answered free of charge, as soon as possible and no later than one month after receipt, however, up to two months if necessary due to the complexity or number of requests. In the event of unfounded or excessive requests, we have the right to reject it or charge a reasonable fee for answering it."
  },
  {
    "type": "p",
    "content": "Your specific possibilities are:"
  },
  {
    "type": "list",
    "items": [
      {
        "text": "Withdraw consent<br>To the extent processing is based on your consent, you may at any time withdraw your consent by contacting us at the below mentioned information or as otherwise explained when you provided your consent. This will not affect the lawfulness of the processing before its withdrawal."
      },
      {
        "text": "Access<br>You have the right to access the personal data that we process about you, as well as certain information about how the processing takes place. No access is granted to information which must remain confidential because of public or private interests, including your own interests."
      },
      {
        "text": "Rectification<br>You have the right to have incorrect personal data corrected or to have incomplete personal data about you completed."
      },
      {
        "text": "Erasure<br>You have the right to have personal data about you deleted in the circumstances specified in Article 17 of the GDPR. This may be the case, for example, if the information is no longer necessary for the fulfilment of our obligations and exercising of our rights or if the information is processed on the basis of your consent which has been withdrawn."
      },
      {
        "text": "Restriction<br>In the circumstances mentioned in Article 18 of the GDPR, you have the right to have the processing of your personal data restricted, e.g. if the accuracy of the data is disputed, in the period until we have had the opportunity to determine whether the personal data is correct or if we no longer need the personal data for the processing but they are necessary to establish, exercise or defend a legal claim."
      },
      {
        "text": "Object<br>You have the right to object to the processing of personal data which we process on the basis of Article 6(1)(f) of the GDPR (the legal basis for processing in our legitimate interest) and always if the processing is for the purpose of direct marketing."
      },
      {
        "text": "Data portability<br>If the processing is based on your consent or contract, you have the right to receive the information in a plain and readable format and to transmit the information to another data controller. If you wish and if technically possible, we will transmit the information directly to this data controller."
      },
      {
        "text": "Automatic decisions<br>You have the right not to be the subject of an automatic decision that has legal effect or similarly significantly affects you, which is based solely on automatic processing, including profiling."
      }
    ]
  },
  {
    "type": "h2",
    "content": "Deletion of data"
  },
  {
    "type": "p",
    "content": "Information required for newsletters is kept until the consent is withdrawn or the consent has not been used for one consecutive year. We keep documentation that you have withdrawn your consent for up to 2 years after the consent has been withdrawn"
  },
  {
    "type": "h2",
    "content": "Security"
  },
  {
    "type": "p",
    "content": "We take security of your information seriously and implement appropriate technical and organizational measures (TOMs) in accordance with GDPR Article 32 to protect it from loss, theft, alteration, or misuse. However, please be advised that even the best security measures cannot fully eliminate all risks. We cannot guarantee that only authorised persons will view your information. We are not responsible for third party circumvention of any privacy settings or security measures. Also note that since frames are designed exclusively for home use, the media presented on them is not hidden behind a password screen and can therefore be physically accessed by anyone in the home."
  },
  {
    "type": "h2",
    "content": "Contact"
  },
  {
    "type": "p",
    "content": "Should you wish to exercise any of your rights or if you have any questions regarding our Privacy Policy, please contact us via email: <a href=\"mailto:support@pexar.com\">support@pexar.com</a>"
  },
  {
    "type": "h2",
    "content": "Supervisory Authority"
  },
  {
    "type": "p",
    "content": "You also have the right to lodge a complaint with the Office of the Privacy Commissioner for Personal Data (PCPD) in Hong Kong or your local supervisory authority if you believe that the processing of your personal data infringes applicable data protection law."
  },
  {
    "type": "h2",
    "content": "Changes to our Privacy Policy"
  },
  {
    "type": "p",
    "content": "We reserve the right to alter our Privacy Policy at any time. Where changes are material, we will notify you in advance with reasonable notice through the Services (such as by posting on our website, email, or in-app notice). If you do not agree to the altered Privacy Policy, you should stop using our Services before the changes take effect."
  },
  {
    "type": "h2",
    "content": "EU Data Act compliance"
  },
  {
    "type": "p",
    "content": "The Pexar Frame software qualifies as an integral part of a connected product (a Digital Photo Frame) within the meaning of Article 2(5) of the EU Data Act. In the context of the Pexar system the following qualify as related services within the meaning of Article 2(6) of the Data Act: the Pexar iOS app and the Pexar Android app. The data relevant to Data Act compliance that Pexar holds and controls are limited to those generated and transmitted by these three services."
  },
  {
    "type": "p",
    "content": "This notice therefore concerns only the product data and related service data that are generated during the use of a photo frame running the Pexar software and that are accessible to and controlled by Pexar via the related services described above."
  },
  {
    "type": "h3",
    "content": "Part A: information about the connected product (Article 3(2) Data Act)"
  },
  {
    "type": "h4",
    "content": "1. Type, format and estimated volume of product data"
  },
  {
    "type": "p",
    "content": "User content data (e.g. videos and photos transferred to a frame) is covered by GDPR in other privacy policy sections and is therefore considered outside the scope of the Data Act."
  },
  {
    "type": "p",
    "content": "Besides user content data, a Pexar frame generates primarily three categories of product data:"
  },
  {
    "type": "list",
    "items": [
      {
        "title": "Application data",
        "text": "This data is core to the function of the frame. It contains feature data (e.g. reactions data, etc.), information about connected apps (i.e. ‘friends’) and data related to app settings. Recorded as structured logs in machine-readable standard formats (XML, comma separated text files and other structured text saved to files). The total size is modest (often just a few megabytes)."
      },
      {
        "title": "Usage data",
        "text": "This data is encapsulated as events that details how features and functionality of the frame have been used. The raw data is temporarily stored in a proprietary binary format on the device. It is then uploaded and stored remotely in a structured, event-based format. The total size is modest (often just a few megabytes for each day’s normal use)."
      },
      {
        "title": "System data",
        "text": "Information about the frame’s hardware/software (device ID, OS version) and operational metrics (uptime, available memory, Wi-Fi status), logged in text (XML and binary data) files. Typical volume is very small in the range of a few kilobytes per day of use."
      }
    ]
  },
  {
    "type": "h4",
    "content": "2. Continuous and real-time generation"
  },
  {
    "type": "p",
    "content": "The product is capable of generating data continuously (real-time) while it is powered on."
  },
  {
    "type": "p",
    "content": "This data is transmitted to our servers in near real-time when the product is connected to the internet. This allows for immediate analysis of performance issues and timely updates to improve your experience."
  },
  {
    "type": "h4",
    "content": "3. Storage and retention"
  },
  {
    "type": "p",
    "content": "The Pexar product is capable of storing data on-device and on remote servers. Specifically:"
  },
  {
    "type": "list",
    "items": [
      {
        "title": "On-device storage",
        "text": "Application data and some system data is stored in the frame’s internal storage. This data remains on the frame until manually deleted by the user (i.e. indefinite retention by default). Some system and environment data may persist a factory reset (e.g. permanent device identifiers such as a serial number)."
      },
      {
        "title": "Remote/server storage",
        "text": "Pexar may store encrypted copies of application data on secure cloud servers to support frame backups upon the user’s own request through interacting with the backup feature of the Services. System logs and anonymized usage data are uploaded for diagnostics. System logs and app usage logs are stored on AWS servers hosted in the United States region. Anonymized usage data may be retained on our servers for as long as it is relevant for statistical purposes. By design, Pexar has implemented an automatic deletion policy: once photos and videos have been successfully received by the frame, they are immediately deleted and no longer retained in the cloud."
      }
    ]
  },
  {
    "type": "h4",
    "content": "4. Access, retrieval and, where relevant, erasure"
  },
  {
    "type": "p",
    "content": "<strong>Data stored on device</strong>"
  },
  {
    "type": "list",
    "items": [
      {
        "title": "Local data retrieval",
        "text": "Accessing local data on the Frame can be done through Android adb access"
      },
      {
        "title": "Data erasure",
        "text": "Users can delete most data at any time. Clearing the data can be done by resetting the frame through the frame Settings. Some system and environment data may persist a factory reset (e.g. permanent device identifiers such as a serial number)."
      }
    ]
  },
  {
    "type": "p",
    "content": "<strong>Data stored remotely</strong>"
  },
  {
    "type": "list",
    "items": [
      {
        "title": "Cloud data requests",
        "text": "To obtain data stored on Pexar's servers, users should contact Pexar Support (<a href=\"mailto:support@pexar.com\">support@pexar.com</a>). Upon request, we will provide a complete copy of the user’s data associated with their Pexar account (delivered to the user’s registered email) within 30 days. There is no charge for such data requests."
      },
      {
        "title": "Data erasure",
        "text": "<span id=\"account-deletion\" style=\"display:block; position:relative; top:-80px; visibility:hidden;\"></span>Users can delete data at any time. To erase remote/server data, users may delete their Pexar account via the App by navigating to <strong>User Center &gt; Profile &gt; More (top-right corner) &gt; Delete Account</strong>, or by submitting a deletion request by contacting our support team. Following account deletion, Pexar will erase all personally identifiable data from its servers as described in this Privacy Policy."
      }
    ]
  },
  {
    "type": "h3",
    "content": "Part B: Information about related services (Article 3(4) DA)"
  },
  {
    "type": "h4",
    "content": "1. Nature, estimated volume and collection frequency of product data obtained by related services"
  },
  {
    "type": "p",
    "content": "In practice, the Pexar Service Apps collect system information from connected frames, e.g. metadata about the relationship between the frame and app, e.g. user permissions granted from the frame. The data volumes are small – typically only a few kilobytes per frame per day under normal use."
  },
  {
    "type": "p",
    "content": "The Pexar Service transmits these product data to Pexar's secure cloud servers as they are generated."
  },
  {
    "type": "h4",
    "content": "2. Nature and estimated volume of related service data"
  },
  {
    "type": "p",
    "content": "The Pexar Service generates the following service data:"
  },
  {
    "type": "list",
    "items": [
      {
        "title": "App usage logs and performance data",
        "text": "The Service logs app usage and behavioral events such as login times, events related to sending photos, changes to app settings, number of connected frames and performance statistics. This data is used in anonymized form to improve the service. Typical volume is small (e.g. each “send photo” event might be a few bytes)."
      }
    ]
  },
  {
    "type": "h4",
    "content": "3. Storage arrangements and retention"
  },
  {
    "type": "p",
    "content": "All related service data generated by the Service is stored on Pexar's cloud servers. Same retention rules apply as described in A.3. Related service logs, including app usage logs, are stored on AWS servers hosted in the United States region."
  },
  {
    "type": "p",
    "content": "Product data obtained by related services may be stored locally on-device. On-device data can be cleared by clearing the app data or uninstalling the app. Accessing the on-device data can be done by following the platform’s (iOS or Android) standard methods for accessing app data."
  },
  {
    "type": "h4",
    "content": "4. Use of readily available data by Pexar and third parties"
  },
  {
    "type": "p",
    "content": "Pexar uses the data collected from the frame and Services for its internal service purposes. For instance, we analyze usage logs and system metrics to troubleshoot issues, optimize performance, bug fixing, and develop new features. Any use of data is in accordance with user agreements and privacy policies."
  },
  {
    "type": "p",
    "content": "By default, Pexar does not share user data with any external third parties for independent use. We do not sell or disclose personal usage data outside Pexar. The only exceptions are as required by law or with the user’s explicit consent. If a user explicitly requests to transfer their data to a third-party service (for example, migrating their photos and logs to another platform), Pexar will enable that transfer as described below. Aside from such cases, Pexar ensures that all data use will be internal."
  },
  {
    "type": "h4",
    "content": "5. Identity and contact of the prospective data holder and other data processing parties"
  },
  {
    "type": "p",
    "content": "The Pexar Services are provided by Pexar Co., Limited (Business registration number 78459467) based in RM2902, 29/F HO KING COMM CTR 2-16 FA YUEN ST MONG KOK HONG KONG. Pexar is the sole data holder for the services; we also engage authorized cloud hosting providers as data processors under contract. Those providers store and process the data on Pexar's behalf but do not act as independent data holders. No other company controls the data we collect from the services."
  },
  {
    "type": "p",
    "content": "Users can reach Pexar at:"
  },
  {
    "type": "list",
    "items": [
      {
        "title": "Email",
        "text": "<a href=\"mailto:support@pexar.com\">support@pexar.com</a>"
      },
      {
        "title": "Postal Address",
        "text": "RM2902, 29/F HO KING COMM CTR 2-16 FA YUEN ST MONG KOK HONG KONG"
      }
    ]
  },
  {
    "type": "p",
    "content": "These channels allow users to quickly contact Pexar about data, technical issues, or account questions."
  },
  {
    "type": "h4",
    "content": "6. How users can request data sharing"
  },
  {
    "type": "p",
    "content": "Pexar fully supports data portability: a user may ask Pexar to provide their data to another service (for example, if switching to a different photo-frame platform). To do this, the user should contact Pexar Support (e.g. via email) and specify which data to share and with which recipient. Upon request, Pexar will package the user’s data (in a structured, machine-readable format) and transfer it to the indicated party, at no cost to the user."
  },
  {
    "type": "h4",
    "content": "7. Complaint right"
  },
  {
    "type": "p",
    "content": "Users have the right to lodge a complaint alleging an infringement of Chapter II of the Data Act with the competent authority designated pursuant to Article 37 of the Data Act."
  },
  {
    "type": "h4",
    "content": "8. Trade secrets"
  },
  {
    "type": "p",
    "content": "Data is not expected to contain trade secrets and as such Pexar does not treat the data as proprietary trade secrets. Should this however be the case, disclosure and access will be provided under safeguards that protect confidentiality, in accordance with the Data Act."
  },
  {
    "type": "h4",
    "content": "9. Terms of use and quality of service for access and transmission"
  },
  {
    "type": "p",
    "content": "Requests under the Data Act are handled without undue delay and free of charge. Data is provided in a structured, commonly used and machine-readable format (e.g. JSON). Availability of the access channel may be subject to maintenance windows and system uptime of the related services and backend systems."
  },
  {
    "type": "h4",
    "content": "10. Duration and termination of the contract between the user and the prospective data holder"
  },
  {
    "type": "p",
    "content": "The Pexar Service is offered under an ongoing user agreement. The user may terminate this contract at any time by deleting their Pexar account, uninstalling the app, or canceling any paid subscription (if applicable). After an account deletion, Pexar will erase all personally identifiable data from its servers as described in our Privacy Policy. Conversely, Pexar may terminate the service if the user violates the terms of use or for other reasons stated in our policies."
  },
  {
    "type": "h4",
    "content": "Additional Information for California Residents"
  },
  {
    "type": "p",
    "content": "How We Source, Use, and Disclose Information for Business Purposes. The following chart details the categories of personal information we collect, the sources of such personal information, and how we use and share such information for business purposes."
  },
  {
    "type": "p",
    "content": "Your California Privacy Rights. If you are a California resident, the California Consumer Privacy Act (“CCPA”) allows you to make certain requests about your personal information. Specifically, the CCPA allows you to request us to:"
  },
  {
    "type": "list",
    "items": [
      {
        "text": "Inform you about the categories of personal information we collect or disclose about you; the categories of sources of such information; the business or commercial purpose for collecting your personal information; and the categories of third parties with whom we share/disclose personal information"
      },
      {
        "text": "Provide access to and/or a copy of certain personal information we hold about you"
      },
      {
        "text": "Delete certain personal information we have about you"
      },
      {
        "text": "Provide you with information about the financial incentives that we offer to you, if any."
      }
    ]
  },
  {
    "type": "p",
    "content": "The CCPA further provides you with the right not to be discriminated against (as provided for in applicable law) for exercising your rights under the statute. Please note that certain information may be exempt from such requests under California law. For example, we need certain information in order to provide our Services to you. We also will take reasonable steps to verify your identity before responding to a request for security purposes. In doing so, we may ask you for verification information so that we can match at least two verification points with information we maintain in our files about you. If we are unable to verify you through this method, we shall have the right, but not the obligation, to request additional information from you."
  },
  {
    "type": "p",
    "content": "If you would like further information regarding your legal rights under California law or would like to exercise any of them, or if you are an authorized agent making a request on a California consumer's behalf, please contact us at <a href=\"mailto:support@pexar.com\">support@pexar.com</a>"
  },
  {
    "type": "p",
    "content": "The CCPA provides certain rights if a company “sells” personal information, as such term is defined under the CCPA. We do not engage in activities that would be considered “sales” of your personal information under the CCPA."
  },
  {
    "type": "p",
    "content": "Shine the Light Disclosure. The California “Shine the Light” law gives residents of California the right under certain circumstances to request information from us regarding the manner in which we share certain categories of personal information (as defined in the Shine the Light law) with third parties for their direct marketing purposes. We do not share your personal information with third parties for their own direct marketing purposes without your affirmative consent."
  },
  {
    "type": "p",
    "content": "Browser “Do Not Track” Signals. Some web browsers may transmit “do-not-track” signals to a website. Because of differences in how web browsers incorporate and activate this feature, it is not always clear whether users intend for these signals to be transmitted, or whether they are aware of them. Because there currently is no industry standard concerning what, if anything, a service should do when they receive such signals, we currently do not take action in response to these signals."
  },
  {
    "type": "p",
    "content": "Last updated: 06/03/2026",
    "className": "last-updated"
  }
];
